export default "__VITE_ASSET__DN2VVMr3__"